import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconPlay from 'components/icons/IconPlay';
import useVideoMetadata from 'hooks/useVideoMetadata';
import PDPDesktopHeroThumbnail from '../PDPDesktopHeroThumbnail';
const PDPDesktopStudioThumbnails = t0 => {
  const $ = _c(12);
  const {
    enableCrops,
    loading: t1,
    openModal,
    pdpIsModularBYOProduct: t2,
    photos: t3,
    selectedPhoto: t4,
    setSelectedPhoto,
    setIsVideoSelected: t5,
    introVideoId,
    mode: t6,
    isVideoSelected,
    viewGalleryImageEvent
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const photos = t3 === undefined ? [] : t3;
  const selectedPhoto = t4 === undefined ? null : t4;
  const setIsVideoSelected = t5 === undefined ? _temp : t5;
  const mode = t6 === undefined ? "pdp" : t6;
  let t7;
  if ($[0] !== introVideoId) {
    t7 = {
      videoId: introVideoId
    };
    $[0] = introVideoId;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const {
    thumbnail: videoThumbnailUrl
  } = useVideoMetadata(t7);
  if (loading) {
    const t8 = mode === "quickview";
    let t9;
    if ($[2] !== t8) {
      t9 = classNames("flex", {
        "max-[1023px]:md:justify-center": t8
      });
      $[2] = t8;
      $[3] = t9;
    } else {
      t9 = $[3];
    }
    let t10;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = [0, 1, 2, 3, 4].map(_temp2);
      $[4] = t10;
    } else {
      t10 = $[4];
    }
    let t11;
    if ($[5] !== t9) {
      t11 = <div className={t9}>{t10}</div>;
      $[5] = t9;
      $[6] = t11;
    } else {
      t11 = $[6];
    }
    return t11;
  }
  if (!photos.length) {
    return null;
  }
  const displayCount = introVideoId ? 4 : 5;
  const firstFivePhotos = photos.slice(0, displayCount);
  const lastIndex = displayCount - 1;
  const t8 = mode === "quickview";
  let t9;
  if ($[7] !== t8) {
    t9 = classNames("flex", {
      "max-[1023px]:md:justify-center": t8
    });
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t11 = firstFivePhotos.map((t10, index) => {
    const {
      id,
      src,
      cropData
    } = t10;
    if (photos.length > 5 && index === lastIndex) {
      if (mode === "quickview") {
        return null;
      }
      return <PDPDesktopHeroThumbnail enableCrops={enableCrops} key={`PDPDesktopHeroThumbnails${id}`} onClick={() => {
        setSelectedPhoto?.({
          type: "studio",
          index: 0
        });
        openModal(id);
      }}>{`+${photos.length - lastIndex}`}</PDPDesktopHeroThumbnail>;
    }
    return <React.Fragment key={`PDPDesktopHeroThumbnails${id}`}>{!!introVideoId && index === 1 && <PDPDesktopHeroThumbnail cropData={cropData} enableCrops={enableCrops} key={-1} src={videoThumbnailUrl} isSelected={isVideoSelected} onClick={setIsVideoSelected} iconCenter={true} icon={<IconPlay width={24} height={24} />} />}<PDPDesktopHeroThumbnail cropData={cropData} enableCrops={enableCrops} key={id} src={src} isSelected={pdpIsModularBYOProduct ? selectedPhoto === id : selectedPhoto === src} onClick={() => {
        setSelectedPhoto?.({
          type: "studio",
          id,
          index,
          src
        });
      }} onMouseEnter={() => {
        setSelectedPhoto?.({
          type: "studio",
          id,
          index,
          src
        });
        viewGalleryImageEvent({
          imageLocation: "Hero Gallery",
          imageFilename: src?.split("/").pop() || "",
          position: index,
          totalImages: photos.length
        });
      }} /></React.Fragment>;
  });
  let t12;
  if ($[9] !== t11 || $[10] !== t9) {
    t12 = <div className={t9}>{t11}</div>;
    $[9] = t11;
    $[10] = t9;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  return t12;
};
PDPDesktopStudioThumbnails.propTypes = {
  enableCrops: PropTypes.bool,
  introVideoId: PropTypes.string,
  isVideoSelected: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  openModal: PropTypes.func,
  pdpIsModularBYOProduct: PropTypes.bool,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  })),
  selectedPhoto: PropTypes.string,
  setSelectedPhoto: PropTypes.func,
  setIsVideoSelected: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func
};
export default PDPDesktopStudioThumbnails;
function _temp() {}
function _temp2(val, idx) {
  return <PDPDesktopHeroThumbnail key={`PDPDesktopHeroThumbnail${idx}`} loading={true} />;
}